import React from 'react';
import View from 'components/tmisc/portal/template_requested/TemplateRequested.view';

const PortalTemplateRequested = () => {
  return (
    <View />
  );
}

export default PortalTemplateRequested;